const initialState = {
  loginDetail: false,
  forgotPasswordLoading: false,
  forgotPasswordSuccess: false,
  forgotPasswordError: null,
  loginWithLicenseLoading: false,
  loginWithLicenseSuccess: false,
  loginWithLicenseError: false,
  showSidebar: true,
};
const LogInReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LogIn":
      return {
        ...state,
        loginDetail: action.payload,
      };
    case "FORGOT_PASSWORD_LOADING":
      return { ...state, forgotPasswordLoading: true };
    case "FORGOT_PASSWORD_SUCCESS":
      return {
        ...state,
        forgotPasswordLoading: false,
        forgotPasswordSuccess: true,
        forgotPasswordError: null,
      };
    case 'FORGOT_PASSWORD_FAILURE':
      return { ...state, forgotPasswordLoading: false, forgotPasswordSuccess: false, forgotPasswordError: action.payload };
    case "FORGOT_PASSWORD_FAILURE":
      return {
        ...state,
        forgotPasswordLoading: false,
        forgotPasswordSuccess: false,
        forgotPasswordError: action.payload,
      };
    case "FORGOT_PASSWORD_RESET":
      return {
        ...state,
        forgotPasswordLoading: false,
        forgotPasswordSuccess: false,
        forgotPasswordError: null,
      };
    case "SHOW_SIDEBAR":
      return {
        ...state,
        showSidebar: true,
      }
    case "HIDE_SIDEBAR":
      return {
        ...state,
        showSidebar: false,
      }
    default:
      return state;
  }
};

export default LogInReducer;
